import React from "react";
import "../styles/Section1.scss";

const Section1 = () => {
  return (
    <section className="section-hero" id="inicio">
      {/* Video de fondo */}
      <video
        autoPlay
        muted
        loop
        playsInline
        preload="metadata"
        className="hero-video"
      >
        <source
          src="https://pixbaebanquetes.com/video.mp4"
          type="video/mp4"
        />
        Tu navegador no soporta el video.
      </video>

      {/* Overlay */}
      <div className="hero-overlay"></div>

      {/* Contenido */}
      <div className="hero-content">
        {/* H1 PRINCIPAL (SEO) */}
        <h1>
          Banquetes al carbón en <br />
          <span className="highlight">
            Guadalajara, Zapopan y Tlajomulco
          </span>
        </h1>

        <p>
          Experiencia gastronómica con chef profesional para eventos
          residenciales y empresariales. Montaje, vajilla y sabor premium
          incluidos.
        </p>

        <a href="#nosotros" className="hero-button">
          Cotiza tu banquete
        </a>
      </div>
    </section>
  );
};

export default Section1;
